var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bcx-all bcx-main-content c-thread-topic-skelleton"},[_c('BCXSkeleton',{staticClass:"breadcrumbs",attrs:{"height":"18px"}}),_c('BCXSkeleton',{staticClass:"title",attrs:{"height":"18px"}}),_c('thread-message-skeleton',{staticClass:"message"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }